<template>
  <div style="position: relative;">
    <el-form ref="JobLevlelRecordFilter" :model="JobLevlelRecord" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="部门名称" prop="formFilter.deptName">
          <el-input class="filter-item" v-model="JobLevlelRecord.formFilter.deptName"
            :clearable="true" placeholder="部门名称"
          />
        </el-form-item>
        <el-form-item label="员工姓名" prop="formFilter.userName">
          <el-input class="filter-item" v-model="JobLevlelRecord.formFilter.userName"
            :clearable="true" placeholder="员工姓名"
          />
        </el-form-item>
        <el-form-item label="薪级名称" prop="formFilter.jobLevelName">
          <el-input class="filter-item" v-model="JobLevlelRecord.formFilter.jobLevelName"
            :clearable="true" placeholder="薪级名称"
          />
        </el-form-item>
        <el-form-item label="岗位工资" prop="formFilter.jobSalary">
          <input-number-range class="filter-item"
            v-model="JobLevlelRecord.formFilter.jobSalary" :clearable="true"
            startPlaceholder="最小值" endPlaceholder="最大值"
          />
        </el-form-item>
        <el-form-item label="描述" prop="formFilter.detail">
          <el-input class="filter-item" v-model="JobLevlelRecord.formFilter.detail"
            :clearable="true" placeholder="描述"
          />
        </el-form-item>
        <el-form-item label="备注" prop="formFilter.remark">
          <el-input class="filter-item" v-model="JobLevlelRecord.formFilter.remark"
            :clearable="true" placeholder="备注"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetJobLevlelRecord">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshJobLevlelRecord(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('JobLevelRecord:JobLevlelRecord:export')"
          @click="onExportClick()">
          导出
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="paJobLevelRecord" :data="JobLevlelRecord.PaJobLevelRecord.impl.dataList" :size="defaultFormItemSize" @sort-change="JobLevlelRecord.PaJobLevelRecord.impl.onSortChange"
          header-cell-class-name="table-header-gray"
          highlight-current-row @current-change="JobLevlelRecord.PaJobLevelRecord.impl.currentRowChange" height="550px"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="JobLevlelRecord.PaJobLevelRecord.impl.getTableIndex" />
          <el-table-column label="部门名称" prop="deptName" sortable="custom">
          </el-table-column>
          <el-table-column label="员工姓名" prop="userName" sortable="custom">
          </el-table-column>
          <el-table-column label="薪级名称" prop="jobLevelName">
          </el-table-column>
          <el-table-column label="岗位工资" prop="jobSalary">
          </el-table-column>
          <el-table-column label="描述" prop="detail">
          </el-table-column>
          <el-table-column label="备注" prop="remark">
          </el-table-column>
          <el-table-column label="薪级文件" min-width="100px">
            <template slot-scope="scope">
              <a v-for="item in parseUploadData(scope.row.jobLevelFilePath, {id: scope.row.id, fieldName: 'jobLevelFilePath', asImage: false})"
                :key="item.url" href="javascript:void(0);" @click="downloadFile(item.url, item.name)">{{item.name}}</a>
            </template>
          </el-table-column>
          <el-table-column label="创建人" prop="createUserIdDictMap.name">
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="JobLevlelRecord.PaJobLevelRecord.impl.totalCount"
            :current-page="JobLevlelRecord.PaJobLevelRecord.impl.currentPage"
            :page-size="JobLevlelRecord.PaJobLevelRecord.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="JobLevlelRecord.PaJobLevelRecord.impl.onCurrentPageChange"
            @size-change="JobLevlelRecord.PaJobLevelRecord.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaJobLevelRecordController, DictionaryController } from '@/api';

export default {
  name: 'JobLevelRecord',
  props: {
    userId: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      JobLevlelRecord: {
        formFilter: {
          deptName: undefined,
          userName: undefined,
          jobLevelName: undefined,
          jobSalary: [],
          detail: undefined,
          remark: undefined
        },
        formFilterCopy: {
          deptName: undefined,
          userName: undefined,
          jobLevelName: undefined,
          jobSalary: [],
          detail: undefined,
          remark: undefined
        },
        PaJobLevelRecord: {
          impl: new TableWidget(this.loadPaJobLevelRecordWidgetData, this.loadPaJobLevelRecordVerify, true, true, 'createTime', 0)
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetJobLevlelRecord () {
      this.$refs.JobLevlelRecordFilter.resetFields();
      this.refreshJobLevlelRecord(true);
    },
    /**
     * 薪级变更记录数据获取函数，返回Promise
     */
    loadPaJobLevelRecordWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paJobLevelRecordDtoFilter: {
          deptName: this.JobLevlelRecord.formFilterCopy.deptName,
          userName: this.JobLevlelRecord.formFilterCopy.userName,
          jobLevelName: this.JobLevlelRecord.formFilterCopy.jobLevelName,
          jobSalaryStart: Array.isArray(this.JobLevlelRecord.formFilterCopy.jobSalary) ? this.JobLevlelRecord.formFilterCopy.jobSalary[0] : undefined,
          jobSalaryEnd: Array.isArray(this.JobLevlelRecord.formFilterCopy.jobSalary) ? this.JobLevlelRecord.formFilterCopy.jobSalary[1] : undefined,
          detail: this.JobLevlelRecord.formFilterCopy.detail,
          remark: this.JobLevlelRecord.formFilterCopy.remark
        }
      }
      return new Promise((resolve, reject) => {
        PaJobLevelRecordController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.JobLevlelRecord.PaJobLevelRecord.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.JobLevlelRecord.PaJobLevelRecord.impl.currentRow.id, 'id');
              this.$refs.paJobLevelRecord.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 薪级变更记录数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaJobLevelRecordVerify () {
      this.JobLevlelRecord.formFilterCopy.deptName = this.JobLevlelRecord.formFilter.deptName;
      this.JobLevlelRecord.formFilterCopy.userName = this.JobLevlelRecord.formFilter.userName;
      this.JobLevlelRecord.formFilterCopy.jobLevelName = this.JobLevlelRecord.formFilter.jobLevelName;
      this.JobLevlelRecord.formFilterCopy.jobSalary = this.JobLevlelRecord.formFilter.jobSalary;
      this.JobLevlelRecord.formFilterCopy.detail = this.JobLevlelRecord.formFilter.detail;
      this.JobLevlelRecord.formFilterCopy.remark = this.JobLevlelRecord.formFilter.remark;
      return true;
    },
    /**
     * 更新定岗记录表
     */
    refreshJobLevlelRecord (reloadData = false) {
      if (reloadData) {
        this.JobLevlelRecord.PaJobLevelRecord.impl.refreshTable(true, 1);
      } else {
        this.JobLevlelRecord.PaJobLevelRecord.impl.refreshTable();
      }
      if (!this.JobLevlelRecord.isInit) {
        // 初始化下拉数据
      }
      this.JobLevlelRecord.isInit = true;
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        paJobLevelRecordDtoFilter: {
          deptName: this.JobLevlelRecord.formFilterCopy.deptName,
          userName: this.JobLevlelRecord.formFilterCopy.userName,
          jobLevelName: this.JobLevlelRecord.formFilterCopy.jobLevelName,
          jobSalaryStart: Array.isArray(this.JobLevlelRecord.formFilterCopy.jobSalary) ? this.JobLevlelRecord.formFilterCopy.jobSalary[0] : undefined,
          jobSalaryEnd: Array.isArray(this.JobLevlelRecord.formFilterCopy.jobSalary) ? this.JobLevlelRecord.formFilterCopy.jobSalary[1] : undefined,
          detail: this.JobLevlelRecord.formFilterCopy.detail,
          remark: this.JobLevlelRecord.formFilterCopy.remark
        }
      };

      PaJobLevelRecordController.export(this, params, '薪级变更记录.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    onResume () {
      this.refreshJobLevlelRecord();
    },
    initFormData () {
    },
    formInit () {
      this.refreshJobLevlelRecord();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
